export default {
  HOME: '/',
  LOGIN: '/login',
  USER_PASSWORD: '/user-password',
  REPORTS: '/reports',
  SEARCH: '/search',
  ORDERS: '/orders',
  ORDER_DETAIL: '/orders/:id',
  MY_ORDERS: '/my-orders',
  CREATE_ORDER: '/create-order',
  CONTRACTS: '/contracts',
  CONTRACT_EDITOR: '/contract-editor/:id?',
  CONTRACT_REVIEW: '/contracts/:id/review',
  CONTRACT_NEW: '/contracts/new',
  CONTRACT_DETAIL: '/contracts/:id',
  CONTRACT_REDEEM: '/contracts/:id/redeem',
  CONTRACT_REPAYMENT: '/contracts/:id/repay',
  CONTRACT_LIQUIDIZATION: '/contracts/:id/liquidize',
  CONTRACT_RENEWAL: '/contracts/:id/renew',
  CONTRACT_REPRINT: '/contracts/:id/reprint',
  PAYMENT_REMINDER: '/payment-reminder',
  PAYMENT_REMINDER_REPORTS: '/payment-reminder/reports',
  VALUE_ADJUSTMENT: '/value-adjustment',
  CLIENTS: '/clients',
  CLIENT_DETAIL: '/clients/:id',
  MARKETING: '/marketing',
  CASH_LOG: '/cash-log',
  CASH_LOG_PENDING_LIST: '/cash-log/pending',
  CASH_LOG_CLOSURE: '/cash-log/closures',
  ASSETS: '/asset',
};
